module.exports = __webpack_public_path__ + "static/media/logo-ntt-data-dark.7ad520f0.svg";